import React, {Component} from 'react';
import {withRouter} from "react-router-dom";
import AirModal from "../../../../../common/components/AirModal";
import Success from "./Success";
import "./PaymentMethodPopup.css"
import PaymentPage from "../../../PaymentPage/PaymentPage";

@withRouter
export default class PaymentMethodPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 'payment'
    }
  }

  onClose = async () => {
    this.props.onCancel();
    this.setState({page: 'payment'});
  }

  onSuccessFullPaymentMethodChange = async () => {
    await this.props.onSuccessFullPaymentMethodChange();
    this.setState({page: 'success'})
  }

  renderContent = () => {

    if(this.state.page === 'payment') {
      return <PaymentPage customerDetails={this.props.customerDetails} onNext={() => this.onSuccessFullPaymentMethodChange()}/>
    }
    if(this.state.page === 'success') {
      return <Success onNext={this.onClose} />
    }
  }

  render() {
    return (
      <AirModal
        className='PaymentMethodPopup'
        visible={this.props.hasOwnProperty('visible') ? this.props.visible : true}
        onCancel={this.onClose}
        buttonsStyle={{ display: 'none' }}
        width={600}
      >
        {this.renderContent()}
      </AirModal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/PaymentManagementDashboard/PaymentManagementCard/PaymentMethodPopup/PaymentMethodPopup.js